module.exports = __webpack_public_path__ + "static/p_pariss-c9e8f04b63e46b75d5dd6f2ea5fc1b8b.jpg";